import type { ExploreContentItemContentOneOfBasicInfoAllOfTwoTweetType } from './exploreContentItemContentOneOfBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type ExploreContentItemContentOneOfBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: ExploreContentItemContentOneOfBasicInfoAllOfTwoTweetType;
};
